import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { NcrMenu } from '@/interfaces/models/NcrMenu';

export default class NcrApiService extends ApiService<any> {
  constructor() {
    super('ncr');
  }

  public syncFoodcard(payload: { venue: string }): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/menu/sync`, payload);
  }

  public getMenus(venueId: string): AxiosPromise<NcrMenu[]> {
    return axios.get(`${this.getBaseUrl()}/menus/${venueId}`);
  }
}
